import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-57ac4a8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ylz_container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "info_content" }
const _hoisted_4 = { class: "info_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_category" }, "站点类别：", -1))
const _hoisted_6 = { style: {"margin-right":"1rem"} }
const _hoisted_7 = { class: "info_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_category" }, "测站编码：", -1))
const _hoisted_9 = { class: "factor_container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "right-box" }
const _hoisted_12 = { class: "condition" }
const _hoisted_13 = { class: "benchmark" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "百分位基准年限：", -1))

import { EChartsType } from 'echarts'
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
import { Api } from '@/api/publicApi'

export default /*#__PURE__*/_defineComponent({
  __name: 'DialogYlz',
  props: {
  data: Object,
},
  setup(__props) {

const { proxy } = getCurrentInstance()
const api = new Api()

const props = __props

const time = ref(new Date())
const selectEchart = ref('时均值')
const currentFactor = ref('')
const currentData = ref({})
const benchmark = ref('1')
const benchmarkOptions = ref([
  {
    label: '1年期',
    value: '1',
  },
  {
    label: '3年期',
    value: '3',
  },
  {
    label: '5年期',
    value: '5',
  },
])
let echart1Object = null
let echart2Object = null
let echart3Object = null
const charts1 = ref()
const charts2 = ref()
const charts3 = ref()
const graphData: any[] = []

const onFactorClick = (type: string) => {
  currentFactor.value = type
  // onFilterChange()
}
const initChart = async (data) => {
  const xdata: any[] = []
  const ydata: any[] = []
  let min = null
  const standardLine = await getStandardLine('水位')
  const markLine: Object = {
    silent: true,
    label: {
      color: '#fff',
    },
    lineStyle: {
      color: '#ffeb3b',
    },
    data: [],
  }
  if (standardLine.sevenLine) {
    markLine.data.push({
      name: '70%分位线',
      yAxis: standardLine.sevenLine,
      label: {
        formatter: '70%分位线',
      },
    })
  }
  if (standardLine.threeLine) {
    markLine.data.push({
      name: '30%分位线',
      yAxis: standardLine.threeLine,
      label: {
        formatter: '30%分位线',
      },
    })
  }
  if (standardLine.medianLine) {
    markLine.data.push({
      name: '平均值',
      yAxis: standardLine.medianLine,
      label: {
        formatter: '平均值',
      },
    })
  }
  data.forEach((item) => {
    xdata.push(item.t)
    ydata.push(item.d || 0)
    if (item.d && !min) {
      min = item.d * 1
    } else if (item.d && item.d * 1 < min * 1) {
      min = item.d * 1
    }
  })

  const colorArr = [
    {
      start: 'rgba(0,211,149,1)',
      end: 'rgba(0,211,149,.1)',
    },
  ]
  const normalColor = '#ffffff'
  const seriesData = []
  let obj1 = {}
  obj1 = {
    // type: 'bar',
    type: 'line',
    data: ydata,
    barWidth: '15%',
    markLine,
    itemStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: `${colorArr[0].start}0.7)`,
            },
            {
              offset: 0.5,
              color: `${colorArr[0].start}0.3)`,
            },
            {
              offset: 1,
              color: colorArr[0].end,
            },
          ],
          globalCoord: false,
        },
      },
    },
  }
  seriesData.push(obj1)
  echart1Object.clear()
  echart1Object.setOption({
    grid: {
      left: '2%',
      top: '14%',
      right: '12%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        name: '时',
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        data: xdata,
        axisPointer: {
          type: 'shadow',
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '水位(M)',
        min: min > 0.2 ? Math.floor((min - 0.2) * 10) / 10 : 0,
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(255, 255, 255, .5)',
          },
        },
      },
    ],
    series: seriesData,
  })
}
const initChart2 = async (data) => {
  const xdata: any[] = []
  const ydata: any[] = []
  const standardLine = await getStandardLine('流量')
  let min = null
  const markLine: Object = {
    silent: true,
    label: {
      color: '#fff',
    },
    lineStyle: {
      color: '#ffeb3b',
    },
    data: [],
  }
  if (standardLine.sevenLine) {
    markLine.data.push({
      name: '70%分位线',
      yAxis: standardLine.sevenLine,
      label: {
        formatter: '70%分位线',
      },
    })
  }
  if (standardLine.threeLine) {
    markLine.data.push({
      name: '30%分位线',
      yAxis: standardLine.threeLine,
      label: {
        formatter: '30%分位线',
      },
    })
  }
  if (standardLine.medianLine) {
    markLine.data.push({
      name: '平均值',
      yAxis: standardLine.medianLine,
      label: {
        formatter: '平均值',
      },
    })
  }

  data.forEach((item) => {
    xdata.push(item.t)
    ydata.push(item.d || 0)
    if (item.d && !min) {
      min = item.d * 1
    } else if (item.d && item.d * 1 < min * 1) {
      min = item.d * 1
    }
  })
  const colorArr = [
    {
      start: 'rgba(31,194,255,1)',
      end: 'rgba(31,194,255,.1)',
    },
  ]
  const normalColor = '#ffffff'
  const seriesData = []
  let obj1 = {}
  obj1 = {
    type: 'line',
    data: ydata,
    // barWidth: '15%',
    markLine,
    itemStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: `${colorArr[0].start}0.7)`,
            },
            {
              offset: 0.5,
              color: `${colorArr[0].start}0.3)`,
            },
            {
              offset: 1,
              color: colorArr[0].end,
            },
          ],
          globalCoord: false,
        },
      },
    },
  }
  seriesData.push(obj1)
  echart2Object.clear()
  echart2Object.setOption({
    grid: {
      left: '2%',
      top: '14%',
      right: '12%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: xdata,
        name: '时',
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisPointer: {
          type: 'shadow',
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '流量(M³/S)',
        min: min > 0.2 ? Math.floor((min - 0.2) * 10) / 10 : 0,
        nameTextStyle: {
          color: normalColor,
          fontSize: 12,
        },
        axisLabel: {
          formatter: '{value}',
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: normalColor,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(255, 255, 255, .5)',
          },
        },
      },
    ],
    series: seriesData,
  })
}
const initChart3 = async (data) => {
  const xdata: any[] = []
  const ydata: any[] = []
  let min = null
  const standardLine = await getStandardLine('雨量')
  const markLine: Object = {
    silent: true,
    label: {
      color: '#fff',
    },
    lineStyle: {
      color: '#ffeb3b',
    },
    data: [],
  }
  if (standardLine.sevenLine) {
    markLine.data.push({
      name: '70%分位线',
      yAxis: standardLine.sevenLine,
      label: {
        formatter: '70%分位线',
      },
    })
  }
  if (standardLine.threeLine) {
    markLine.data.push({
      name: '30%分位线',
      yAxis: standardLine.threeLine,
      label: {
        formatter: '30%分位线',
      },
    })
  }
  if (standardLine.medianLine) {
    markLine.data.push({
      name: '平均值',
      yAxis: standardLine.medianLine,
      label: {
        formatter: '平均值',
      },
    })
  }
  data.forEach((item) => {
    xdata.push(item.t)
    ydata.push(item.d || 0)
    if (item.d && !min) {
      min = item.d * 1
    } else if (item.d && item.d * 1 < min * 1) {
      min = item.d * 1
    }
  })
  const normalColor = '#ffffff'
  echart3Object.clear()
  echart3Object.setOption({
    grid: {
      left: '2%',
      top: '14%',
      right: '12%',
      bottom: 0,
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        name: '时',
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: 'rgba(155,208,255,.5)',
          },
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        splitLine: {
          show: false,
        },
        boundaryGap: false,
        data: xdata,
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '降雨量(mm)',
        min: min > 0.2 ? Math.floor((min - 0.2) * 10) / 10 : 0,
        nameTextStyle: {
          color: normalColor,
          fontSize: 14,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: 'rgba(155,208,255,.5)',
          },
        },
        axisLabel: {
          textStyle: {
            color: normalColor,
            fontSize: 14,
          },
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: 'rgba(255, 255, 255, .5)',
          },
        },
      },
    ],
    series: [
      {
        name: '降雨量',
        type: 'line',
        showAllSymbol: true,
        symbol: 'circle',
        symbolSize: 10,
        itemStyle: {
          color: '#ffe16a',
        },
        lineStyle: {
          width: 2,
          type: 'dotted',
          color: '#ffe16a',
        },
        tooltip: {
          show: false,
        },
        markLine,
        data: ydata,
      },
    ],
  })
}

const select = (val) => {
  selectEchart.value = val
}

const selectChange = (val) => {
  benchmark.value = val
  getData()
}

const getStandardLine = async (factor) => {
  let data = null
  const param = {
    ageLimit: benchmark.value,
    factor,
    indexCode: props.data.id,
  }
  const res = await api.screen.getSwSiteStandardLineUsingPost(param)
  if (res.code === 200) {
    data = res.data
  }
  return data
}

const getData = async () => {
  await api.screen
    .getSwSiteDetailAndGraphUsingPost({ indexCode: props.data.id, time: format(time.value) })
    .then((res) => {
      if (res.code === 200) {
        currentData.value = res.data
        currentFactor.value = currentData.value.datas[0].name
        for (let i = 0; i < currentData.value.datas.length; i++) {
          switch (currentData.value.datas[i].name) {
            case '水位':
              initChart(currentData.value.datas[i].item)
              break
            case '流量':
              initChart2(currentData.value.datas[i].item)
              break
            case '雨量':
              initChart3(currentData.value.datas[i].item)
              break
            default:
          }
        }
      } else {
      }
    })
}

const onTimeChange = async (value) => {
  time.value = value
  getData()
  //   getSwslGraphUsingGET({
  //     factor: this.currentFactor,
  //     tm: this.$moment(this.time).format('yyyy-MM-DD'),
  //     indexCode: this.currentData.stcd,
  //     zl: this.currentData.type,
  //   }).then((data) => {
  //     this.graphData = data;
  //     console.log(this.graphData, 'graphdata');
  //     switch (this.currentFactor) {
  //       case '水位': {
  //         this.initChart();
  //         break;
  //       }
  //       case '流量': {
  //         this.initChart2();
  //         break;
  //       }
  //       case '雨量': {
  //         this.initChart3();
  //         break;
  //       } default: {
  //         console.log('default');
  //       }
  //     }
  //   });
}

function add0(m) {
  return m < 10 ? '0' + m : m
}
function format(shijianchuo) {
  //shijianchuo是整数，否则要parseInt转换
  const time = new Date(shijianchuo)
  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()
  const h = time.getHours()
  // var mm = time.getMinutes();
  // var s = time.getSeconds();
  // return y+'-'+add0(m)+'-'+add0(d)+' '+add0(h)+':'+add0(mm)+':'+add0(s);
  return y + '-' + add0(m) + '-' + add0(d)
}

onMounted(() => {
  //   currentData.value = props.data
  //   currentFactor.value = currentData.value.factors[0]
  //   // time.value = this.$moment().format('yyyy-MM-DD')
  //   graphData = currentData.value.datas[0].item
  getData()
  echart1Object = proxy.$echarts.init(charts1.value)
  echart2Object = proxy.$echarts.init(charts2.value)
  echart3Object = proxy.$echarts.init(charts3.value)
  // initChart()
  // initChart2()
  // initChart3()
})

return (_ctx: any,_cache: any) => {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_select = _resolveComponent("n-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(currentData).stnm), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(currentData).type), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", null, _toDisplayString(_unref(currentData).stcd), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentData).factors, (factor, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["factor", { active: _unref(currentFactor) === factor }]),
          onClick: ($event: any) => (onFactorClick(factor))
        }, _toDisplayString(factor), 11, _hoisted_10))
      }), 128)),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_n_date_picker, {
          value: _unref(time),
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(time) ? (time).value = $event : null)),
          size: "small",
          type: "date",
          clearable: "",
          "on-update:value": onTimeChange,
          format: "yyyy-MM-dd"
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_n_select, {
          value: _unref(benchmark),
          "onUpdate:value": [
            _cache[1] || (_cache[1] = ($event: any) => (_isRef(benchmark) ? (benchmark).value = $event : null)),
            selectChange
          ],
          options: _unref(benchmarkOptions)
        }, null, 8, ["value", "options"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "charts1",
      ref: charts1,
      class: "charts_container"
    }, null, 512), [
      [_vShow, _unref(currentFactor) === '水位']
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "charts2",
      ref: charts2,
      class: "charts_container"
    }, null, 512), [
      [_vShow, _unref(currentFactor) === '流量']
    ]),
    _withDirectives(_createElementVNode("div", {
      ref_key: "charts3",
      ref: charts3,
      class: "charts_container"
    }, null, 512), [
      [_vShow, _unref(currentFactor) === '雨量']
    ])
  ]))
}
}

})